import { render, staticRenderFns } from "./comment_list.vue?vue&type=template&id=cfa29c46&scoped=true&"
import script from "./comment_list.vue?vue&type=script&lang=js&"
export * from "./comment_list.vue?vue&type=script&lang=js&"
import style0 from "./comment_list.vue?vue&type=style&index=0&id=cfa29c46&prod&scoped=true&lang=css&"
import style1 from "./comment_list.vue?vue&type=style&index=1&id=cfa29c46&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfa29c46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VCol,VDivider,VIcon,VOverlay,VRow,VTextarea})
